import { EditorController } from '@ibiz-template/runtime';
import { ICheckBox } from '@ibiz/model-core';

/**
 * 选项框编辑器控制器
 *
 * @export
 * @class CheckBoxEditorController
 * @extends {EditorController}
 */
export class CheckBoxEditorController extends EditorController<ICheckBox> {}
